import React from 'react'
import styled from 'styled-components'

import Button from 'components/lib/DesignSystem/Button'

class SlackSecondStep extends React.Component {
  handleStepRedirect = (changeInIndex) => {
    this.props.changeWizardIndex(this.props.wizardIndex + changeInIndex)
  }

  render() {
    const { className } = this.props

    return (
      <div className={className}>
        <img
          src="/static/webapp/images/settings/slack-second-screenshot.png"
          className="screenshot"
        />
        <div className="actions-container">
          <div className="mt">
            <div className="number-indication">1</div>
            <span className="text-indication">
              Choose a channel where you will receive notifications
            </span>
          </div>
          <div className="mt">
            <div className="number-indication">2</div>
            <span className="text-indication">
              Confirm and click on “Add Incoming WebHooks integration”.
            </span>
          </div>
        </div>
        <div className="buttons-container">
          <Button
            text="Back"
            styleType="secondary"
            onClick={() => this.handleStepRedirect(-1)}
            className="smr"
            id="slack-backButton"
          />
          <Button
            text="Next Step"
            onClick={() => this.handleStepRedirect(1)}
            className="sml"
            id="slack-nextButton"
          />
        </div>
      </div>
    )
  }
}

export default styled(SlackSecondStep)`
  .buttons-container {
    margin-top: 113px;
  }
`
